import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";

import { fetchToken, fetchUser } from "../clients/auth.client";
import { Login } from "../components/auth/Login/Login";
import Center from "../components/layout/Center/Center";
import i18n, { LANG_KEY } from "../i18next";
import { login } from "../reducers/auth.reducer";

const SUPPORTED_LANGUAGES = new Set(["en", "ru", "uk"]);

export const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [errorField, setErrorField] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const emailRef = useRef(null);

  const showError = (message, field = "") => {
    setErrorMessage(message);
    setErrorField(field);
    if (field === "credentials") {
      window.requestAnimationFrame(() => emailRef.current?.focus());
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setErrorField("");
    setIsSubmitting(true);

    const userForm = new FormData(event.currentTarget);
    const loginData = {
      email: String(userForm.get("email") ?? "").trim(),
      password: String(userForm.get("password") ?? ""),
    };

    try {
      const token = await fetchToken(loginData);
      if (token === undefined) {
        showError(t("auth.invalidCredentials"), "credentials");
        return;
      }

      const user = await fetchUser(token);
      if (!user) {
        showError(t("auth.profileLoadFailed"));
        return;
      }

      const profileLanguage = user.language === "ua" ? "uk" : user.language;
      if (SUPPORTED_LANGUAGES.has(profileLanguage)) {
        localStorage.setItem(LANG_KEY, profileLanguage);
        await i18n.changeLanguage(profileLanguage);
      }

      dispatch(login(user, token));
      navigate("../", { replace: true });
    } catch {
      showError(t("auth.signInFailed"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Center useFreeHeightSpace={true}>
      <form onSubmit={handleSubmit}>
        <Login
          emailRef={emailRef}
          errorField={errorField}
          errorMessage={errorMessage}
          isSubmitting={isSubmitting}
        />
      </form>
    </Center>
  );
};
